import {
  type ExcelMapperValues,
  type PriceColumnRole,
  priceColumnRoles,
} from '../UrlExcelMapper/UrlExcelMapper.types'

export type PriceColumnValues = Record<PriceColumnRole, string>

const isPriceColumnRole = (field: string): field is PriceColumnRole =>
  priceColumnRoles.some((role) => role.value === field)

export const toPriceMapperValues = (
  values: PriceColumnValues
): ExcelMapperValues =>
  Object.fromEntries(
    priceColumnRoles.map(({ value }) => [
      value,
      values[value].trim() === '' ? undefined : Number(values[value]),
    ])
  )

export const splitPriceMapping = (values: ExcelMapperValues) => {
  const stock: ExcelMapperValues = {}
  const prices: Partial<PriceColumnValues> = {}
  Object.entries(values).forEach(([field, value]) => {
    if (isPriceColumnRole(field))
      prices[field] = value === undefined ? '' : String(value)
    else Object.assign(stock, { [field]: value })
  })
  return { stock, prices }
}
